/**
 * Textarea — primitive de controle multiligne.
 *
 * Pas de prop `label` / `error` — toujours wrappe par <Field> ou <FormTextarea>.
 *
 * `autosize` : la textarea grandit pour afficher tout le texte saisi (CSS
 * `field-sizing: content`). `rows` reste la hauteur minimale.
 */
import { forwardRef, type TextareaHTMLAttributes } from 'react'

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  autosize?: boolean
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, rows = 3, autosize = false, ...rest },
  ref,
) {
  const classes = ['ui-textarea', autosize && 'ui-textarea--autosize', className]
    .filter(Boolean)
    .join(' ')
  return <textarea ref={ref} rows={rows} className={classes} {...rest} />
})

export default Textarea
